import {
  MnemonicLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { GraphemeMnemonicsMeaningScreenSuspense } from "#grapheme-mnemonics-meaning-screen-suspense";

export function GraphemeMnemonicsMeaningScreen() {
  return (
    <SuspensePageBoundary fallback={<MnemonicLayoutSkeleton />} location={import.meta.location}>
      <GraphemeMnemonicsMeaningScreenSuspense />
    </SuspensePageBoundary>
  );
}
